import dayjs, { Dayjs } from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

const BR_FORMAT = 'DD/MM/YYYY';
const API_FORMAT = 'YYYY-MM-DD';

const STRICT_FORMATS = [
  BR_FORMAT,
  API_FORMAT,
  'YYYY-MM-DDTHH:mm:ss',
  'YYYY-MM-DDTHH:mm:ss.SSS',
  'YYYY-MM-DDTHH:mm:ssZ',
];

type DateInput = string | number | Date | Dayjs | null | undefined;

const isEmpty = (value: DateInput): boolean =>
  value === null || value === undefined || (typeof value === 'string' && value.trim() === '');

export function parseAnyToDayjs(value: DateInput): Dayjs | null {
  if (isEmpty(value)) return null;

  if (dayjs.isDayjs(value)) {
    return value.isValid() ? value : null;
  }

  if (value instanceof Date) {
    const d = dayjs(value);
    return d.isValid() ? d : null;
  }

  if (typeof value === 'number') {
    const d = dayjs(value);
    return d.isValid() ? d : null;
  }

  const str = String(value).trim();

  // Tenta cada formato em modo strict.
  for (const fmt of STRICT_FORMATS) {
    const parsed = dayjs(str, fmt, true);
    if (parsed.isValid()) return parsed;
  }

  // Último recurso: parser nativo (ISO completo, etc.).
  const fallback = dayjs(str);
  return fallback.isValid() ? fallback : null;
}

export function formatToBr(value: DateInput): string {
  const d = parseAnyToDayjs(value);
  return d ? d.format(BR_FORMAT) : '';
}

export function formatToApi(value: DateInput): string | null {
  const d = parseAnyToDayjs(value);
  return d ? d.format(API_FORMAT) : null;
}

export function isInvalidDateInput(value: DateInput): boolean {
  if (isEmpty(value)) return false;
  return parseAnyToDayjs(value) === null;
}

/**
 * Data de parcela no formato que a API espera (`YYYY-MM-DDT00:00:00`), aceitando
 * Date, string em pt-BR ou ISO. Usada no envio da matrícula e da venda avulsa.
 */
export function normalizeDataParcelaToApi(value: DateInput): string | undefined {
  const d = parseAnyToDayjs(value);
  return d ? d.format('YYYY-MM-DD[T]00:00:00') : undefined;
}
